import "./text_block.scss";

export const EncyclopediaTextBlock = (props: {
	title?: string;
	content?: string;
}) => {
	return (
		<div className="text_block">
			{props.title && (
				<div className="text_block__title">{props.title}</div>
			)}
			{props.content && (
				<div className="text_block__content">{props.content}</div>
			)}
		</div>
	);
};
